import { useEffect } from 'react'
import { useDesaDetail } from '../hooks/use-desa-public'

export function DocumentHead() {
  const { data: desa, isLoading } = useDesaDetail()

  // Update document title
  useEffect(() => {
    if (!isLoading) {
      const title = desa?.name || 'Website Desa'
      document.title = title
    }
  }, [desa?.name, isLoading])

  // Update favicon
  useEffect(() => {
    if (!isLoading) {
      // Remove existing favicon
      const existingFavicon = document.querySelector("link[rel*='icon']")
      if (existingFavicon) {
        existingFavicon.remove()
      }

      // Only set favicon if logo URL is available
      if (desa?.logoUrl) {
        const link = document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = desa.logoUrl
        document.getElementsByTagName('head')[0].appendChild(link)
      }
    }
  }, [desa?.logoUrl, isLoading])

  return null // This component doesn't render anything
}